module.exports = __webpack_public_path__ + "static/img/about_title_text_1.b117495.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/about_title_text_1.png
// module id = td+N
// module chunks = 1